import { useCallback, useState } from 'react';

import { convertMilliseconds } from '@swf/core/utils';

import useInterval from './useInterval';

const getTimeUnits = (countDown: number) => {
  const { days, hours, minutes, seconds } = convertMilliseconds(countDown);

  return { days, hours, minutes, seconds };
};

const useCountdown = (endDate: string, intervalMs = 10 * 1000) => {
  const dateMs = isNaN(Date.parse(endDate)) ? new Date().getTime() : new Date(endDate).getTime();

  const [countdownMs, setCountdown] = useState(dateMs - new Date().getTime());

  const setCountdownFn = useCallback(() => {
    setCountdown(dateMs - new Date().getTime());
  }, [dateMs]);

  useInterval(setCountdownFn, intervalMs, intervalMs);

  return getTimeUnits(countdownMs);
};

export { useCountdown };
